// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PaperworkReportCode {
    REPORTJUSTIFYINGTREATMENTBEYONDUTILIZATIONGUIDELINES = 'REPORT_JUSTIFYING_TREATMENT_BEYOND_UTILIZATION_GUIDELINES',
    DRUGSADMINISTERED = 'DRUGS_ADMINISTERED',
    TREATMENTDIAGNOSIS = 'TREATMENT_DIAGNOSIS',
    INITIALASSESSMENT = 'INITIAL_ASSESSMENT',
    FUNCTIONALGOALS = 'FUNCTIONAL_GOALS',
    PLANOFTREATMENT = 'PLAN_OF_TREATMENT',
    PROGRESSREPORT = 'PROGRESS_REPORT',
    CONTINUEDTREATMENT = 'CONTINUED_TREATMENT',
    CHEMICALANALYSIS = 'CHEMICAL_ANALYSIS',
    CERTIFIEDTESTREPORT = 'CERTIFIED_TEST_REPORT',
    JUSTIFICATIONOFADMISSION = 'JUSTIFICATION_OF_ADMISSION',
    RECOVERYPLAN = 'RECOVERY_PLAN',
    ALLERGIESSENSITIVITIESDOCUMENT = 'ALLERGIES_SENSITIVITIES_DOCUMENT',
    AUTOPSYREPORT = 'AUTOPSY_REPORT',
    AMBULANCECERTIFICATION = 'AMBULANCE_CERTIFICATION',
    ADMISSIONSUMMARY = 'ADMISSION_SUMMARY',
    PRESCRIPTION = 'PRESCRIPTION',
    PHYSICIANORDER = 'PHYSICIAN_ORDER',
    REFERRALFORM = 'REFERRAL_FORM',
    BENCHMARKTESTINGRESULTS = 'BENCHMARK_TESTING_RESULTS',
    BASELINE = 'BASELINE',
    BLANKETTESTRESULTS = 'BLANKET_TEST_RESULTS',
    CHIROPRACTICJUSTIFICATION = 'CHIROPRACTIC_JUSTIFICATION',
    CONSENTFORMS = 'CONSENT_FORMS',
    CERTIFICATION = 'CERTIFICATION',
    DRUGPROFILEDOCUMENT = 'DRUG_PROFILE_DOCUMENT',
    DENTALMODELS = 'DENTAL_MODELS',
    DURABLEMEDICALEQUIPMENTPRESCRIPTION = 'DURABLE_MEDICAL_EQUIPMENT_PRESCRIPTION',
    DIAGNOSTICREPORT = 'DIAGNOSTIC_REPORT',
    DISCHARGEMONITORINGREPORT = 'DISCHARGE_MONITORING_REPORT',
    DISCHARGESUMMARY = 'DISCHARGE_SUMMARY',
    EXPLANATIONOFBENEFITS = 'EXPLANATION_OF_BENEFITS',
    HEALTHCERTIFICATE = 'HEALTH_CERTIFICATE',
    HEALTHCLINICRECORDS = 'HEALTH_CLINIC_RECORDS',
    IMMUNIZATIONRECORD = 'IMMUNIZATION_RECORD',
    STATESCHOOLIMMUNIZATIONRECORDS = 'STATE_SCHOOL_IMMUNIZATION_RECORDS',
    LABORATORYRESULTS = 'LABORATORY_RESULTS',
    MEDICALRECORDATTACHMENT = 'MEDICAL_RECORD_ATTACHMENT',
    MODELS = 'MODELS',
    NURSINGNOTES = 'NURSING_NOTES',
    OPERATIVENOTE = 'OPERATIVE_NOTE',
    OXYGENCONTENTAVERAGINGREPORT = 'OXYGEN_CONTENT_AVERAGING_REPORT',
    ORDERSANDTREATMENTSDOCUMENT = 'ORDERS_AND_TREATMENTS_DOCUMENT',
    OBJECTIVEPHYSICALEXAMINATIONDOCUMENT = 'OBJECTIVE_PHYSICAL_EXAMINATION_DOCUMENT',
    OXYGENTHERAPYCERTIFICATION = 'OXYGEN_THERAPY_CERTIFICATION',
    SUPPORTDATAFORCLAIM = 'SUPPORT_DATA_FOR_CLAIM',
    PATHOLOGYREPORT = 'PATHOLOGY_REPORT',
    PATIENTMEDICALHISTORYDOCUMENT = 'PATIENT_MEDICAL_HISTORY_DOCUMENT',
    PARENTERALORENTERALCERTIFICATION = 'PARENTERAL_OR_ENTERAL_CERTIFICATION',
    PHYSICALTHERAPYNOTES = 'PHYSICAL_THERAPY_NOTES',
    PROSTHETICSORORTHOTICCERTIFICATION = 'PROSTHETICS_OR_ORTHOTIC_CERTIFICATION',
    PARAMEDICALRESULTS = 'PARAMEDICAL_RESULTS',
    PHYSICIANSREPORT = 'PHYSICIANS_REPORT',
    PHYSICALTHERAPYCERTIFICATION = 'PHYSICAL_THERAPY_CERTIFICATION',
    RADIOLOGYFILMS = 'RADIOLOGY_FILMS',
    RADIOLOGYREPORTS = 'RADIOLOGY_REPORTS',
    REPORTOFTESTSANDANALYSISREPORT = 'REPORT_OF_TESTS_AND_ANALYSIS_REPORT',
    RENEWABLEOXYGENCONTENTAVERAGINGREPORT = 'RENEWABLE_OXYGEN_CONTENT_AVERAGING_REPORT',
    SYMPTOMSDOCUMENT = 'SYMPTOMS_DOCUMENT',
    DEATHNOTIFICATION = 'DEATH_NOTIFICATION',
    PHOTOGRAPHS = 'PHOTOGRAPHS'
}

export function PaperworkReportCodeFromJSON(json: any): PaperworkReportCode {
    return json as PaperworkReportCode;
}

export function PaperworkReportCodeToJSON(value?: PaperworkReportCode): any {
    return value as any;
}

